export class PlaneraEvents {
    static readonly mouseOverArbetsorderChanged = "productionplanning_mouseOverArbetsorderChanged";
    static readonly mouseOverArbetsorderTab = "productionplanning_mouseOverArbetsorderTab";
    static readonly mouseOverAtgardChanged = "productionplanning_mouseOverAtgardChanged";
    static readonly selectChanged = "productionplanning_selectChanged";
    static readonly selectAllChanged = "productionplanning_selectAllChanged";
    static readonly toggleTab = "productionplanning_toggleTab";
    static readonly selectHandelssortiment = "select-handelssortiment";
    static readonly theaterView = "productionplanning_theaterView";
}

export interface ISelectAOEvent extends IPlaneraEvent{
    beteckning: string;
    selected: boolean;
}

export interface IPlaneraEvent {
    origin: string;
}

export interface IMouseOverArbetsorderChangedEvent extends IPlaneraEvent {
    id: string;
    beteckning: string;
    isMouseover: boolean;
}

export interface IPlaneraTheaterView extends IPlaneraEvent {
    theaterViewActive: boolean;
}
